export default "__VITE_ASSET__405bd273__"